/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { Wrap, } from './styles';

import { applyLabelSetting } from 'services/utils/layerUtils';

import Scale from '../../../../../../../../MapView/components/MapArea/components/Scale';
import GridHorizontalTwoMaps from '../../../../Permanent/Print/views/PrintView/components/GridHorizontalTwoMaps';
import GridVertical from '../../../../Permanent/Print/views/PrintView/components/GridVertical';

import parseGeoraster from 'georaster';
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import L from 'leaflet';
import NonTiledLayer from "leaflet.nontiledlayer";
import { useEffect, useRef, useState, useCallback } from "react";


export const PrintTwoBasemapsView = ({
    mapInstanceLeft,
    mapInstanceRight,
    enabled,
    basemaps,
    map,
    layersPrintMap,
    layoutOrientation = 'vertical',
    gridCheck = false,
    arrayCoordinatesX = [],
    arrayCoordinatesY = [],
    onCoordinatesUpdate
}) => {
    const mapContainerLeft = useRef(null);
    const mapContainerRight = useRef(null);
    const [mapsReady, setMapsReady] = useState(false);
    const layersMapLeft = useRef([]);
    const layersMapRight = useRef([]);
    const syncRef = useRef(false);
    // eslint-disable-next-line no-unused-vars
    const [rightMapScale, setRightMapScale] = useState(null);

    const baseWidth = 620;   // altera posicionamento da grade vertical
    const baseHeight = 620;  // altera posicionamento da grade horizontal
    const gridOffset = 23;
    const containerWidth = gridCheck ? baseWidth - gridOffset : baseWidth;
    const containerHeight = gridCheck ? baseHeight - gridOffset : baseHeight;
    const marginLeft = gridCheck ? gridOffset : 0;
    const marginTop = gridCheck ? gridOffset : 0;
    const [leftMapCoordinatesX, setLeftMapCoordinatesX] = useState([]);
    const [leftMapCoordinatesY, setLeftMapCoordinatesY] = useState([]);
    const [rightMapCoordinatesX, setRightMapCoordinatesX] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [rightMapCoordinatesY, setRightMapCoordinatesY] = useState([]);
    const [scaleReady, setScaleReady] = useState(false);
    const scaleComponentRef = useRef(null);

    // Busca as camadas diretamente do contexto do mapa
    const { layers } = require('views/MapView/hooks').useMap();

    const getStoredDates = () => {
        try {
            const leftSide = localStorage.getItem('leftSide');
            const rightSide = localStorage.getItem('rightSide');
            const mapPlanet = localStorage.getItem('mapPlanet');

            if (leftSide && rightSide) {
                const [leftMonth, leftYear] = leftSide.split('/').map(Number);
                const [rightMonth, rightYear] = rightSide.split('/').map(Number);

                return {
                    left: {
                        month: leftMonth,
                        year: leftYear,
                        formatted: `${leftYear}-${leftMonth.toString().padStart(2, '0')}`
                    },
                    right: {
                        month: rightMonth,
                        year: rightYear,
                        formatted: `${rightYear}-${rightMonth.toString().padStart(2, '0')}`
                    },
                    mapPlanet: mapPlanet
                };
            }
        } catch (error) {
            console.error('Erro ao ler datas do localStorage:', error);
        }
        return null;
    };

    // Cria camada base com data
    const createBaseMapWithDate = (dateInfo, basemaps) => {
        const baseMapMapPrint = basemaps?.find((basemap) => basemap.active);

        if (!baseMapMapPrint) {
            return L.tileLayer('https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                attribution: '© Google'
            });
        }

        let attribution = baseMapMapPrint.layer.options.attribution;
        let tileUrl = baseMapMapPrint.layer._url;

        if (baseMapMapPrint.atribuicao?.includes("(ano)") && dateInfo) {
            const formattedDate = `${dateInfo.month.toString().padStart(2, '0')}/${dateInfo.year}`;

            attribution = baseMapMapPrint.atribuicao
                .replace(/\(ano\)/g, formattedDate) // usa data formatada
                .replace(/\d{1,2}\/\d{4}/g, formattedDate);
        }

        // Atualiza URL com a data no formato correto
        if (dateInfo && tileUrl) {
            tileUrl = tileUrl
                .replace(/{year}/g, dateInfo.year)
                .replace(/{month}/g, dateInfo.month.toString().padStart(2, '0'))
                .replace(/{date}/g, dateInfo.formatted);

            const monthlyPattern = /global_monthly_(\d{4})_(\d{2})_mosaic/g;

            if (monthlyPattern.test(tileUrl)) {
                tileUrl = tileUrl.replace(
                    monthlyPattern,
                    `global_monthly_${dateInfo.year}_${dateInfo.month.toString().padStart(2, '0')}_mosaic`
                );
            }
        }

        return L.tileLayer(tileUrl, {
            attribution: attribution,
            noWrap: true,
            detectRetina: false,
            timestamp: Date.now() + Math.random()
        });
    };

    // Sincroniza os mapas
    const syncMaps = (source, target) => {
        if (syncRef.current) return;
        syncRef.current = true;

        target.setView(source.getCenter(), source.getZoom(), {
            animate: false,
            reset: true
        });

        setTimeout(() => { syncRef.current = false; }, 100);
    };

    // Obtém camadas válidas diretamente do contexto
    const getValidLayers = useCallback(() => {
        let validLayers = [];
        if (!layers) return validLayers;

        layers.forEach((layer) => {
            if (layer.visible) {
                validLayers.push({ aliasName: layer.alias, layer: layer });
            }
        });

        return validLayers;
    }, [layers]);

    const createDynamicScale = useCallback(() => {
        if (!mapInstanceRight.current) return null;

        // Scale temporário
        const tempDiv = document.createElement('div');
        tempDiv.className = 'scale leaflet-control-scale';
        tempDiv.style.cssText = `
            background: white;
            border: 2px solid rgba(0,0,0,0.2);
            border-top: none;
            padding: 0 5px;
            font-size: 11px;
            line-height: 18px;
            color: black;
            box-shadow: 0 0 0 1px rgba(255,255,255,0.5);
            white-space: nowrap;
            overflow: hidden;
            box-sizing: content-box;
        `;

        // Calcula a escala baseado no zoom e bounds do mapa
        const bounds = mapInstanceRight.current.getBounds();
        const zoom = mapInstanceRight.current.getZoom();

        // Calcula distância em metros
        const maxMeters = mapInstanceRight.current.distance(
            bounds.getNorthWest(),
            bounds.getNorthEast()
        );

        let scaleText = '1 km';
        const mapWidth = mapInstanceRight.current.getSize().x;
        const meterPerPixel = maxMeters / mapWidth;
        const scaleWidth = 100;
        const scaleMeters = meterPerPixel * scaleWidth;

        if (scaleMeters < 1000) {
            scaleText = `${Math.round(scaleMeters)} m`;
        } else {
            scaleText = `${(scaleMeters / 1000).toFixed(1)} km`;
        }

        tempDiv.textContent = scaleText;
        tempDiv.style.width = `${scaleWidth}px`;

        return tempDiv;
    }, [mapInstanceRight]);


    // Configura tooltips para camadas
    const configureTooltip = (oldLayer, newLayer) => {
        try {
            if (!oldLayer.leafletLayer || !oldLayer.leafletLayer._layers) return;

            const firstLayerKey = Object.keys(oldLayer.leafletLayer._layers)[0];
            if (!firstLayerKey) return;

            const featureTooltip = oldLayer.leafletLayer._layers[firstLayerKey].getTooltip();
            if (!featureTooltip) return;

            let settingsLabel = {};
            if (newLayer._layers) {
                Object.values(newLayer._layers).forEach((feature) => {
                    settingsLabel = {
                        ...featureTooltip.options,
                        feature: feature,
                    };
                    applyLabelSetting(settingsLabel);
                });
            }
        } catch (error) {
            console.error('Erro ao configurar tooltip:', error);
        }
    };

    const updateCoordinates = () => {
        if (!mapsReady || !mapInstanceLeft.current || !mapInstanceRight.current) {
            return;
        }

        const leftCoords = calculateCoordinates(mapInstanceLeft.current);
        const rightCoords = calculateCoordinates(mapInstanceRight.current);

        setLeftMapCoordinatesX(leftCoords.x);   // 4 coordenadas X
        setLeftMapCoordinatesY(leftCoords.y);   // 8 coordenadas Y
        setRightMapCoordinatesX(rightCoords.x); // 4 coordenadas X
        setRightMapCoordinatesY(rightCoords.y); // 8 coordenadas Y

        // envia coordenadas para PrintView
        if (onCoordinatesUpdate && typeof onCoordinatesUpdate === 'function') {
            onCoordinatesUpdate({
                leftX: leftCoords.x,
                leftY: leftCoords.y,
                rightX: rightCoords.x,
                rightY: rightCoords.y
            });
        } else {
            console.error('Erro ao atualizar coordenadas');
        }
    };

    // Cria uma nova camada a partir dos dados originais
    const createLayerFromOriginal = (validLayer, targetMap) => {
        try {
            const layerFromMapApp = validLayer.layer;
            const layerAliasName = layerFromMapApp.type === 'externa'
                ? layerFromMapApp.properties.titulo
                : validLayer.aliasName;
            const layerType = layerFromMapApp.type;
            const service = layerFromMapApp.additionalProps?.service;

            let newLayerToMapPrint = null;

            // Para camadas importadas/criadas/WFS - recria o GeoJSON
            if (layerFromMapApp.type === 'importada' || layerFromMapApp.type === 'criada' || service === 'WFS') {
                if (!layerFromMapApp.leafletLayer || !layerFromMapApp.leafletLayer.toGeoJSON) {
                    return null;
                }

                // Estilização da camada
                let layerStyle = {
                    ...layerFromMapApp.layerStyle,
                    opacity: layerFromMapApp.layerStyle.opacity,
                    fillOpacity: layerFromMapApp.layerStyle.fillOpacity,
                };

                const customRender = L.canvas({ pane: 'mixedPanePrint' });

                let options = {
                    pane: 'mixedPanePrint',
                    renderer: customRender,
                    style: function (feature) {
                        if (layerFromMapApp.classList && layerFromMapApp.classList.length > 0) {
                            let featureStyle = layerFromMapApp.classList.find((c) =>
                                c.value === feature.properties[layerFromMapApp.classColumn]
                            );

                            if (featureStyle) {
                                return {
                                    ...layerStyle,
                                    color: featureStyle.simbology.fillColor,
                                    fillColor: featureStyle.simbology.fillColor,
                                };
                            }
                        }
                        return layerStyle;
                    },
                };

                // Para geometrias de ponto
                if (layerFromMapApp.dataType === 'Point' ||
                    layerFromMapApp.dataType === 'MultiPoint' ||
                    layerFromMapApp.dataType === 'Text') {

                    layerStyle.fillOpacity = layerStyle.opacity;
                    options.pointToLayer = function (feature, latlng) {
                        if (layerFromMapApp.dataType === 'Text') {
                            return L.marker(latlng, {
                                pane: 'mixedPanePrint',
                                renderer: customRender,
                                textMarker: true,
                                text: feature.properties.Texto,
                            });
                        } else {
                            return L.circleMarker(latlng, {
                                pane: 'mixedPanePrint',
                                ...layerStyle,
                                renderer: customRender,
                            });
                        }
                    };
                }

                // Cria camada GeoJSON a partir dos dados originais
                const geoJsonData = layerFromMapApp.leafletLayer.toGeoJSON();
                newLayerToMapPrint = L.geoJSON(geoJsonData, options);
                configureTooltip(layerFromMapApp, newLayerToMapPrint);

            }
            // Para camadas raster importadas
            else if (layerFromMapApp.type === 'importada-raster') {
                return {
                    type: 'raster',
                    fileRaster: layerFromMapApp.geoRasterLayer,
                    aliasName: layerAliasName,
                    options: { opacity: layerFromMapApp.layerStyle.opacity }
                };
            }
            // Para camadas WMS externas
            else {
                const optionsWms = {
                    layers: layerFromMapApp.getLayerNameParam(),
                    format: 'image/png',
                    transparent: true,
                    pane: 'mixedPanePrint',
                    tiled: true,
                    opacity: layerFromMapApp.layerStyle.opacity,
                };

                if (layerFromMapApp.properties?.srs && L.CRS[layerFromMapApp.properties.srs]) {
                    optionsWms.crs = L.CRS[layerFromMapApp.properties.srs];
                }

                const serviceLink = layerFromMapApp.getServiceLink(layerFromMapApp.getService());

                if (layerFromMapApp.additionalProps?.mainMenu) {
                    newLayerToMapPrint = new NonTiledLayer.WMS(serviceLink, {
                        ...optionsWms,
                        crossOrigin: 'anonymous',
                    });
                } else {
                    newLayerToMapPrint = L.tileLayer.wms(serviceLink, optionsWms);
                }
            }

            if (newLayerToMapPrint && newLayerToMapPrint.addTo) {
                newLayerToMapPrint.aliasName = layerAliasName;
                newLayerToMapPrint.type = layerType;
            }

            return newLayerToMapPrint;

        } catch (error) {
            console.error('Erro ao criar camada:', error);
            return null;
        }
    };

    const calculateCoordinates = (map) => {
        if (!map) return { x: [], y: [] };

        const bounds = map.getBounds();

        // COORDENADAS X: APENAS 4 PARA HORIZONTAL
        const west = bounds.getWest();
        const east = bounds.getEast();
        const xStep = (east - west) / 3; // 4 pontos = 3 intervalos

        const xCoords = [];
        for (let i = 0; i < 4; i++) {
            const longitude = west + (xStep * i);
            xCoords.push(`${longitude.toFixed(5)}°`);
        }

        // COORDENADAS Y: 8 PARA VERTICAL (PADRÃO GRIDVERTICAL) =====
        const north = bounds.getNorth();
        const south = bounds.getSouth();
        const yStep = (north - south) / 7; // 8 pontos = 7 intervalos

        const yCoords = [];
        for (let i = 0; i < 8; i++) {
            const latitude = north - (yStep * i); // Norte para Sul
            yCoords.push(`${latitude.toFixed(5)}°`);
        }

        return { x: xCoords, y: yCoords };
    };

    // Adiciona todas as camadas ao mapa
    const addAllLayersToMap = (targetMap, layersArrayRef) => {
        // Limpa camadas anteriores
        layersArrayRef.current.forEach((layer) => {
            if (layer && targetMap.hasLayer && targetMap.hasLayer(layer)) {
                targetMap.removeLayer(layer);
            }
        });
        layersArrayRef.current = [];

        // Cria pane se não existir
        if (!targetMap.getPane('mixedPanePrint')) {
            const mixedPane = targetMap.createPane('mixedPanePrint');
            if (mixedPane) mixedPane.style.zIndex = 300;
        }

        // Busca camadas válidas e cria novas instâncias
        const validLayers = getValidLayers();

        validLayers.forEach((validLayer, index) => {
            try {
                const newLayer = createLayerFromOriginal(validLayer, targetMap);

                if (newLayer) {
                    // Para camadas raster
                    if (newLayer.type === 'raster' && newLayer.fileRaster) {
                        const fileReader = new FileReader();
                        fileReader.onloadend = (e) => {
                            parseGeoraster(e.target.result)
                                .then((georaster) => {
                                    const rasterLayer = new GeoRasterLayer({
                                        georaster,
                                        opacity: newLayer.options?.opacity || 1,
                                        resolution: 256
                                    });
                                    rasterLayer.addTo(targetMap);
                                    layersArrayRef.current.push(rasterLayer);
                                })
                                .catch((error) => console.error('Erro ao processar raster:', error));
                        };
                        fileReader.readAsArrayBuffer(newLayer.fileRaster);
                    }
                    // Para outras camadas
                    else if (newLayer.addTo) {
                        newLayer.addTo(targetMap);
                        layersArrayRef.current.push(newLayer);

                        if (newLayer.setZIndex) {
                            newLayer.setZIndex(validLayers.length - index + 10);
                        }
                    }
                }
            } catch (error) {
                console.error('Erro ao processar camada:', error);
            }
        });
    };

    useEffect(() => {
        if (!enabled || !basemaps || !map || !layers) {
            return;
        }

        const storedDates = getStoredDates();
        if (!storedDates) {
            return;
        }

        // Limpa containers
        if (mapContainerLeft.current) mapContainerLeft.current.innerHTML = '';
        if (mapContainerRight.current) mapContainerRight.current.innerHTML = '';

        // Obtem centro e zoom do mapa principal
        const center = map.getCenter();
        const zoom = map.getZoom();

        // Inicializa os mapas
        mapInstanceLeft.current = L.map(mapContainerLeft.current, {
            center: [center.lat, center.lng],
            zoom: zoom,
            zoomControl: false,
            preferCanvas: true
        });

        mapInstanceRight.current = L.map(mapContainerRight.current, {
            center: [center.lat, center.lng],
            zoom: zoom,
            zoomControl: false,
            preferCanvas: true
        });

        // Oculta controle de zoom lado esquerdo
        // L.control.zoom({ position: 'topright' }).addTo(mapInstanceLeft.current);

        // Adiciona controles de zoom
        L.control.zoom({ position: 'topright' }).addTo(mapInstanceRight.current);

        // Cria e adiciona camadas base
        const leftBaseLayer = createBaseMapWithDate(storedDates.left, basemaps);
        const rightBaseLayer = createBaseMapWithDate(storedDates.right, basemaps);
        leftBaseLayer.addTo(mapInstanceLeft.current);
        rightBaseLayer.addTo(mapInstanceRight.current);

        // Adiciona camadas vetoriais 
        addAllLayersToMap(mapInstanceLeft.current, layersMapLeft);
        addAllLayersToMap(mapInstanceRight.current, layersMapRight);

        // Sincroniza movimentos dos mapas
        const syncLeftToRight = () => syncMaps(mapInstanceLeft.current, mapInstanceRight.current);
        const syncRightToLeft = () => syncMaps(mapInstanceRight.current, mapInstanceLeft.current);

        mapInstanceLeft.current.on('moveend', syncLeftToRight);
        mapInstanceRight.current.on('moveend', syncRightToLeft);

        // Força redimensionamento
        setTimeout(() => {
            if (mapInstanceLeft.current && mapInstanceRight.current) {
                mapInstanceLeft.current.invalidateSize();
                mapInstanceRight.current.invalidateSize();
                setMapsReady(true);
            }
        }, 300);

        // Função de limpeza
        return () => {
            if (mapInstanceLeft.current) {
                mapInstanceLeft.current.off('moveend', syncLeftToRight);
                mapInstanceLeft.current.remove();
                mapInstanceLeft.current = null;
            }
            if (mapInstanceRight.current) {
                mapInstanceRight.current.off('moveend', syncRightToLeft);
                mapInstanceRight.current.remove();
                mapInstanceRight.current = null;
            }
            setMapsReady(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, basemaps, map, layers, getValidLayers]);

    useEffect(() => {
        if (mapsReady && mapInstanceLeft.current && mapInstanceRight.current) {
            // Atualiza coordenadas inicialmente
            updateCoordinates();

            // Atualiza coordenadas sempre que o mapa mudar
            const leftMap = mapInstanceLeft.current;
            const rightMap = mapInstanceRight.current;

            const onMoveEnd = () => {
                updateCoordinates();
            };

            leftMap.on('moveend', onMoveEnd);
            rightMap.on('moveend', onMoveEnd);

            return () => {
                leftMap.off('moveend', onMoveEnd);
                rightMap.off('moveend', onMoveEnd);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mapsReady]);

    useEffect(() => {
        if (mapsReady && mapInstanceRight.current) {
            const updateScale = () => {
                // Usa o mesmo elemento hidden-scale-map do mapa principal
                const hiddenScaleMap = document.getElementById('hidden-scale-map');

                if (hiddenScaleMap) {
                    // Limpa conteúdo anterior
                    while (hiddenScaleMap.firstChild) {
                        hiddenScaleMap.removeChild(hiddenScaleMap.firstChild);
                    }

                    // Cria nova escala
                    const scaleElement = createDynamicScale();
                    if (scaleElement) {
                        hiddenScaleMap.appendChild(scaleElement);
                        setScaleReady(true);
                    }
                }
            };

            // Atualiza escala inicialmente
            updateScale();

            // Atualiza quando o mapa mover ou der zoom
            mapInstanceRight.current.on('moveend zoomend', updateScale);

            return () => {
                if (mapInstanceRight.current) {
                    mapInstanceRight.current.off('moveend zoomend', updateScale);
                }
            };
        }
    }, [mapsReady, createDynamicScale, mapInstanceRight]);

    return (
        <Wrap>
            <div className="map-side" style={{
                width: '100%',
                borderLeft: '1px solid #e5e5e5',
                position: 'relative'
            }}>
                <div className="container-map" style={{
                    width: '100%',
                    marginTop: '-8px',
                    display: 'flex',
                    justifyContent: 'center',
                    position: 'relative',
                }}>
                    {/* Grade Vertical */}
                    {gridCheck && (
                        <div style={{
                            position: 'absolute',
                            left: `${(680 - containerWidth) / 2 - 23}px`,
                            top: `${marginTop}px`,
                            height: `${containerHeight}px`,
                            zIndex: 1001,
                            pointerEvents: 'none'
                        }}>
                            <GridVertical
                                arrayY={leftMapCoordinatesY?.length === 8 ? leftMapCoordinatesY : arrayCoordinatesY}
                            />
                        </div>
                    )}

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative'
                    }}>
                        <div
                            data-testid="two-maps-container"
                            style={{
                                display: 'flex',
                                flexDirection: layoutOrientation === 'vertical' ? 'row' : 'column',
                                width: `${containerWidth}px`,
                                height: `${containerHeight}px`,
                                position: 'relative',
                                marginLeft: `${marginLeft}px`,
                                marginTop: `${marginTop}px`
                            }}
                        >
                            {/* Primeiro Mapa */}
                            <div
                                ref={mapContainerLeft}
                                className="two-maps-left"
                                style={{
                                    width: layoutOrientation === 'vertical' ? 'calc(50% - 1px)' : '100%',
                                    height: layoutOrientation === 'vertical' ? '100%' : 'calc(50% - 1px)',
                                    visibility: mapsReady ? 'visible' : 'hidden',
                                    position: 'relative'
                                }}
                            >
                                {/* Label do primeiro mapa */}
                                <div style={{
                                    position: 'absolute',
                                    top: '8px',
                                    left: '8px',
                                    background: 'rgba(255,255,255,0.95)',
                                    padding: '4px 8px',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    zIndex: 1000,
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}>
                                    {(() => {
                                        const leftSide = localStorage.getItem('leftSide');
                                        return leftSide || (layoutOrientation === 'vertical' ? 'Mapa Esquerdo' : 'Mapa Superior');
                                    })()}
                                </div>
                            </div>

                            {/* Separador */}
                            <div style={{
                                width: layoutOrientation === 'vertical' ? '2px' : '100%',
                                height: layoutOrientation === 'vertical' ? '100%' : '2px',
                                background: `linear-gradient(to ${layoutOrientation === 'vertical' ? 'bottom' : 'right'}, #ccc 0%, #888 50%, #ccc 100%)`,
                                position: 'relative',
                                zIndex: 1001,
                                flexShrink: 0
                            }} />

                            {/* Segundo Mapa */}
                            <div
                                ref={mapContainerRight}
                                className="two-maps-right"
                                style={{
                                    width: layoutOrientation === 'vertical' ? 'calc(50% - 1px)' : '100%',
                                    height: layoutOrientation === 'vertical' ? '100%' : 'calc(50% - 1px)',
                                    visibility: mapsReady ? 'visible' : 'hidden',
                                    position: 'relative'
                                }}
                            >
                                {/* Label do segundo mapa */}
                                <div style={{
                                    position: 'absolute',
                                    top: '8px',
                                    left: '8px',
                                    background: 'rgba(255,255,255,0.95)',
                                    padding: '4px 8px',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    zIndex: 1000,
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}>
                                    {(() => {
                                        const rightSide = localStorage.getItem('rightSide');
                                        return rightSide || (layoutOrientation === 'vertical' ? 'Mapa Direito' : 'Mapa Inferior');
                                    })()}
                                </div>

                                {/* Escala dois mapas */}
                                {mapsReady && (
                                    <div
                                        className="bottomRight scale"
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            bottom: '20px',
                                            zIndex: 1000,
                                            pointerEvents: 'none'
                                        }}
                                    >
                                        <Scale map={mapInstanceRight.current} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {gridCheck && mapsReady && (
                            <div style={{
                                width: `${containerWidth}px`,
                                marginLeft: `${marginLeft}px`,
                                marginTop: '5px'
                            }}>
                                <GridHorizontalTwoMaps
                                    leftMapCoordinatesX={leftMapCoordinatesX}
                                    rightMapCoordinatesX={rightMapCoordinatesX}
                                    layoutOrientation={layoutOrientation}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Wrap>
    );
};

export default PrintTwoBasemapsView;